import React from "react";
import { NavLink } from "react-router-dom";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import Testimonials from "../../components/home/Testimonials";
import Cta from "../../components/cta/cta";
import techBanner from "../../assets/images/technology/techBannerImg.png";
import aiPoweredAutomation from "../../assets/images/technology/AI-powered-automation.png";
import bigDataIntegration from "../../assets/images/technology/big-data-integration.png";
import cloudBasedScale from "../../assets/images/technology/cloud-based-scalablity.png";
import advanceCustomization from "../../assets/images/technology/advance-customization.png";
import techSalesMarketing from "../../assets/images/technology/tech-sales-marketing.png";
import iotIntegration from "../../assets/images/technology/IOT-integration.png";
import continuousInnovation from "../../assets/images/technology/continous-innovation.png";

const TechnologyPage = () => {
  const customGridTemplateColumns = "repeat(2, 1fr)";
  const customGap24 = "24px";

  return (
    <>
      <div className="keyFeat-wrapper">
        <section className="dataE-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="text-center">
                <h1 className="heading39px roboto-bold mb10 text-color-131415">
                  Tech Up Your{" "}
                  <span
                    className="text-primary-color"
                    style={{ fontStyle: "italic" }}
                  >
                    Sales Game
                  </span>
                </h1>
                <p className="heading16px roboto-regular mb20 text-color-131415">
                  Welcome to the Future of sales and Marketing!
                </p>
                <ul className="btn-sec mb30">
                  <li>
                    <NavLink
                      to={"/signup"}
                      className="common-btn-class main-btn-primary roboto-regular"
                    >
                      Get Started
                    </NavLink>
                  </li>
                </ul>

                <img
                  src={techBanner}
                  className="img-responsive position-relative"
                  alt="Supercharge Your Campaigns with Accurate and Comprehensive Data"
                />
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section>
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center mb60 max-width950">
                <div className="company-search-etc">
                  <h3 className="heading24px roboto-bold mb10">
                    The Future of Technology in sales and Marketing Automation
                  </h3>
                  <p className="heading16px roboto-regular mb20">
                    At our core, we believe technology is the key to unlocking
                    limitless potential. By combining cutting-edge tools with
                    intuitive designs, we aim to simplify complex processes and
                    empower businesses to focus on innovation and growth.
                  </p>
                  <p className="heading16px roboto-regular">
                    From AI to IoT, we’re not just following the technology
                    revolution—we’re leading it. Our mission is to help
                    businesses harness the latest innovations to stay
                    competitive, adaptive, and successful in an ever-changing
                    market.
                  </p>
                </div>
                <div>
                  <img
                    src={techSalesMarketing}
                    alt="Lead Capture"
                    className="img-responsive"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="homeServices-wrapper _border-top">
          <div className="max-container">
            <div className="padd-90">
              <h2 className="roboto-bold mb40 text-center heading29px">
                Features That’ll Make You Go WOW!
              </h2>

              <div
                className="grid-auto-fit max-width950"
                style={{
                  "--grid-columns": customGridTemplateColumns,
                  "--grid-gap": customGap24,
                }}
              >
                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={aiPoweredAutomation}
                    alt="AI-Powered Automation"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    AI-Powered Automation
                  </h3>
                  <p className="heading16px roboto-regular">
                    Our platform uses artificial intelligence to automate
                    repetitive tasks, deliver predictive insights, and optimize
                    workflows. From lead scoring to customer engagement, AI
                    ensures smarter decisions and faster results.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={bigDataIntegration}
                    alt="Big Data Integration"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Big Data Integration
                  </h3>
                  <p className="heading16px roboto-regular">
                    Harness the power of big data with tools that analyze vast
                    datasets to provide actionable insights. Understand customer
                    behavior, predict trends, and refine strategies based on
                    real-time data.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={cloudBasedScale}
                    alt="Cloud-Based Scalability"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Cloud-Based Scalability
                  </h3>
                  <p className="heading16px roboto-regular">
                    Built on robust cloud technology, our tool ensures seamless
                    scalability to match your business growth. Enjoy 24/7
                    access, enhanced security, and minimal downtime.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={advanceCustomization}
                    alt="Advanced Customization"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Advanced Customization
                  </h3>
                  <p className="heading16px roboto-regular">
                    Our platform adapts to your unique needs with customizable
                    modules, ensuring that your team gets the exact tools they
                    need to succeed.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={iotIntegration}
                    alt="IoT Integration"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    IoT Integration
                  </h3>
                  <p className="heading16px roboto-regular">
                    Stay connected to the world of devices. With IoT-enabled
                    features, track customer interactions across multiple
                    touchpoints and create a unified experience.
                  </p>
                </div>

                <div className="common-white-box homeServicesBox common-shadow text-center">
                  <img
                    src={continuousInnovation}
                    alt="Continuous Innovation"
                    className="img-responsive mb20"
                    loading="lazy"
                  />
                  <h3 className="heading20px roboto-bold mb10">
                    Continuous Innovation
                  </h3>
                  <p className="heading16px roboto-regular">
                    We don’t just stop at delivering today’s technology. Our
                    dedicated R&D team is always working to enhance the
                    platform, integrating new technologies like machine
                    learning, blockchain, and advanced APIs to future-proof your
                    business.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Ready to transform your business with the latest technology?"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};

export default TechnologyPage;
